import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {
  getCompanyDetailsDropdownApi,
  postCompanyDetailsApi,
  updateCompanyDetailsApi,
} from "../../API/API";

function* fetchCompanyDetailsDropdown(action) {
  try {
    // const { _id } = action.payload;
    const response = yield call(() => getCompanyDetailsDropdownApi());
    yield put({
      type: types.GET_COMPANY_DETAILS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_COMPANY_DETAILS_FAILURE, error });
  }
}

function* postCompanyDetails(action) {
  const { onSuccess, onError, isProfileEdit, ...apiPayload } = action.payload;
  try {
    const apiFn = isProfileEdit ? updateCompanyDetailsApi : postCompanyDetailsApi;
    const response = yield call(() => apiFn(apiPayload));
    
    yield put({
      type: types.POST_COMPANY_DETAILS_SUCCESS,
      payload: response.data,
    });
    if(response?.data?.Professions?.ProfessionCode){
       localStorage.setItem("profession", response.data.Professions.ProfessionCode);
    }
    localStorage.setItem('companyDetails', JSON.stringify(response.data.profile));

    // Keep the profile slice in step with the WizardFlow we just saved, so the
    // routes stop treating a completed signup as still mid-wizard.
    const savedWizardFlow =
      response?.data?.WizardFlow ??
      response?.data?.Profiles?.WizardFlow ??
      apiPayload?.WizardFlow;
    if (savedWizardFlow != null) {
      yield put({
        type: types.SYNC_PROFILE_WIZARD_FLOW,
        payload: savedWizardFlow,
      });
    }

    if (onSuccess) {
      yield call(onSuccess); 
    }
  } catch (error) {
    yield put({ type: types.POST_COMPANY_DETAILS_FAILURE, error });

    if (onError) {
        yield call(onError, error);
    }
  }
}

export function* watchCompanyDetailsDropdown() {
  yield takeEvery(
    types.GET_COMPANY_DETAILS_REQUESTED,
    fetchCompanyDetailsDropdown
  );
}

export function* watchCompanyDetailsSaga() {
  yield takeEvery(types.POST_COMPANY_DETAILS_REQUESTED, postCompanyDetails);
}
